export interface HelperAppState {
  loading: boolean;
}

const helperApp: HelperAppState = {
  loading: false,
};

export default helperApp;
